import { render, staticRenderFns } from "./ServiceTypeEdit.vue?vue&type=template&id=5cf20857&scoped=true&"
import script from "./ServiceTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf20857",
  null
  
)

export default component.exports